<template>
  <CRow>
    <CCol col="12">
      <CButtonToolbar>
        <CButton size="lg" color="ghost-success" shape="pill" @click="$router.push({name: 'New Page',})"><CIcon size="lg" name="cil-plus"/></CButton>
      </CButtonToolbar>
    </CCol>
    <CCol col="12">
      <CCard>
        <CCardBody>
          <CDataTable
            hover
            striped
            tableFilter
            columnFilter
            sorter
            :fields="pageBuildersUiMetaWithAction"
            :items="pageBuilders"
            :items-per-page="20"
            clickable-rows
            :active-page="activePage"
            @row-clicked="rowClicked"
            :pagination="{ doubleArrows: false, align: 'center'}"
            @page-change="pageChange"
            :noItemsView="{ noResults: i18nMessage.NoFilteredResultsAvailable, noItems: i18nMessage.NoItemsAvailable }"
          >
            <template #action="{item}">
              <td style="width: 20px;">
                <CButtonToolbar>
                  <CButton 
                    color="ghost-success" 
                    shape="pill"
                    @click="(e) => onOpenPreview(e, item.path)"
                  >
                    <CIcon size="lg" name="cil-find-in-page"/>
                  </CButton>
                </CButtonToolbar>
              </td>
            </template>
            <template #updated_at="{item}">
              <td>
                {{item.updated_at ? new Date(item.updated_at).format('yyyy-MM-dd hh:mm:ss') : ''}}
              </td>
            </template>
            <template #created_at="{item}">
              <td>
                {{item.created_at ? new Date(item.created_at).format('yyyy-MM-dd hh:mm:ss') : ''}}
              </td>
            </template>
          </CDataTable>
          <div style="text-align: center; color: #4f5d73">{{i18nMessage.TotalRows}}: {{pageBuilders.length}}</div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { mapState, mapActions, mapMutations, } from 'vuex'

export default {
  name: 'PageBuilders',
  data () {
    return {
      activePage: 1,
    }
  },
  computed: {
    ...mapState({
      i18nMessage: state => state.i18nMessage,
      pageBuilders: state => state.pageBuilder.pageBuilders,
      pageBuildersUiMeta: state => state.pageBuilder.pageBuildersUiMeta,
    }),
    pageBuildersUiMetaWithAction () {
      const uiMetaWithAction = this.pageBuildersUiMeta.slice()
      uiMetaWithAction.push({
        key: 'action',
        label: '',
      })
      return uiMetaWithAction
    }
  },
  methods: {
    ...mapActions({
      listPageBuilders: 'pageBuilder/listPageBuilders',
    }),
    ...mapMutations({
      setPageBuilders: 'pageBuilder/setPageBuilders',
    }),
    rowClicked (item) {
      this.$router.push({path: `page-builder/${item.invisible_id}`})
    },
    pageChange (val) {
      this.$router.push({ query: { page: val }})
    },
    onOpenPreview(e, path) {
      if (path.endsWith('/')) {
        path = path.substr(0, path.length - 1)
      }
      const routeData = this.$router.resolve({
        path: '/page-preview' + path,
      })
      window.open(routeData.href, '_blank')
      e.stopPropagation()
    }
  },
  created () {
  },
  mounted () {
    this.listPageBuilders()
  },
  destroyed () {
    this.setPageBuilders([])
  },
  watch: {
    $route: {
      immediate: true,
      handler (route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page)
        }
      }
    }
  },
}
</script>